export default __webpack_public_path__ + "static/media/connect-email-fb-img.82e2d5e4.png";